import { render, staticRenderFns } from "./ServizioPeriodicoServiziTable.vue?vue&type=template&id=7783d475&"
import script from "./ServizioPeriodicoServiziTable.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoServiziTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports